import styled from 'styled-components';

export const StyledAppointmentDetailsCancelButton = styled.div`
   margin-right: auto;
`;
StyledAppointmentDetailsCancelButton.displayName = 'StyledAppointmentDetailsCancelButton';
